import { GentuLogo } from "@vitality-ds/icons";
import { CircleAlert, CircleCheck, Info, TriangleAlert } from "lucide-react";
import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var DEFAULT_ICONS = {
  warning: /*#__PURE__*/_jsx(TriangleAlert, {}),
  info: /*#__PURE__*/_jsx(Info, {}),
  neutral: /*#__PURE__*/_jsx(Info, {}),
  success: /*#__PURE__*/_jsx(CircleCheck, {}),
  critical: /*#__PURE__*/_jsx(CircleAlert, {}),
  accent: /*#__PURE__*/_jsx(Info, {}),
  brand: /*#__PURE__*/_jsx(GentuLogo, {}),
  primary: /*#__PURE__*/_jsx(Info, {})
};
export default DEFAULT_ICONS;